import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import toast from "react-hot-toast";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  useCreateFaqMutation,
  useGetFaqByIdQuery,
  useUpdateFaqMutation,
} from "../../../features/api/faqApiSlice";
import LoadingSpinner from "../../loader/Loader";

const AdminAddEditFaq = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [editingMode, setEditingMode] = useState(false);

  const [createFaq, { isLoading }] = useCreateFaqMutation();
  const [updateFaq, { isLoading: isLoadingUpdating }] = useUpdateFaqMutation();

  const { data: faq, isLoading: faqLoading } = useGetFaqByIdQuery(id, {
    skip: !id, // Skip query if no invoiceId is provided
  });

  useEffect(() => {
    if (id) {
      setEditingMode(true);
    }
  }, [id]);

  // Handle form submission
  const handleSubmit = async (values) => {
    try {
      if (editingMode) {
        const response = await updateFaq({
          id,
          ...values,
        }).unwrap();
        toast.success(response?.message || "Faq updated successfully!");
        navigate("/admin/faqs");
      } else {
        const response = await createFaq({
          ...values,
        }).unwrap();
        toast.success(response?.message || "Faq added successfully!");
        navigate("/admin/faqs");
      }
    } catch (error) {
      toast.error(
        error?.data?.message || "An error occurred, please try again."
      );
    }
  };

  if (isLoading || isLoadingUpdating || faqLoading) return <LoadingSpinner />;

  // add schema validation
  const validateFaq = Yup.object().shape({
    question: Yup.string().required("Question is required"),
    answer: Yup.string().required("Answer is required"),
  });

  return (
    <div className="dashboard-wrapper">
      <div className="dashboard-top-section">
        <div className="dash-top-flex">
          {editingMode ? <h2>Edit Faq</h2> : <h2>Add Faq</h2>}
          <button onClick={() => navigate("/admin/faqs")}>Faqs</button>
        </div>
      </div>

      <Formik
        initialValues={{
          id,
          question: faq?.question || "",
          answer: faq?.answer || "",
        }}
        validationSchema={validateFaq}
        onSubmit={handleSubmit}
        enableReinitialize
      >
        {({ isSubmitting, values, setFieldValue }) => (
          <Form>
            <div>
              <label htmlFor="question">Question</label>
              <Field type="text" name="question" />
              <ErrorMessage name="question" component="div" className="error" />
            </div>

            <div>
              <label htmlFor="answer">Answer:</label>
              <ReactQuill
                className="custom-quill-editor"
                value={values.answer || ""}
                onChange={(value) => setFieldValue("answer", value)}
                name="answer"
              />
              <ErrorMessage name="answer" component="div" className="error" />
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className="form-button"
            >
              {editingMode ? "Update Faq" : "Add Faq"}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AdminAddEditFaq;
